export const searchSteps = [
  {
    target: ".header_search_widget",
    title: "Search Anywhere",
    content: "Find investment opportunities across the nation.",
    disableBeacon: true,
    placement: "auto",
    locale: {
      next: "Next",
    },
  },
  {
    target: ".listing_list_style",
    title: "Narrow Your Search",
    content: "Enhance your search results by using filters.",
    disableBeacon: true,
    placement: "auto",
    locale: {
      next: "Next",
    },
  },
  {
    target: ".take-tour-srp:first-child",
    title: "Browse Property Details",
    content: "Learn important details like pricing, location and availability.",
    placement: "auto",
    disableBeacon: true,
    locale: {
      last: "Get Started",
    },
    styles: {
      buttonNext: {
        backgroundColor: "#108cf4",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "33px",
        width: "auto",
        boxShadow: "0px 3px 10px #b3b2af",
        border: "2px solid #108cf4",
        fontFamily:"graphikregular"
      },
      spotlight:{
        height:"240px !important",
        width:"100%"
      }
    },
  },
];

export const pdpSteps = [
  {
    target: ".bid_center_widget",
    title: "Get Auction Info",
    content:
      "Before the auction, see when and where to bid. Once the aution starts, place your bid!",
    disableBeacon: true,
    placement: "auto",
    locale: {
      next: "Next",
    },
  },
  {
    target: ".tour-pdp-details",
    title: "See Property Details",
    content:
      "Learn important property details, occupancy status and property type.",
    disableBeacon: true,
    placement: "auto",
    locale: {
      last: "Get Started",
    },
    styles: {
      buttonNext: {
        backgroundColor: "#108cf4",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "33px",
        width: "auto",
        boxShadow: "0px 3px 10px #b3b2af",
        border: "2px solid #108cf4",
        fontFamily:"graphikregular"
      },
    },
  },
];

export const tourStyles = {
  options: {
    zIndex: 99999,
    arrowColor: "#fff",
    backgroundColor: "#fff",
    overlayColor: "rgba(0, 0, 0, 0.5)",
    primaryColor: "#0061fd", // your theme blue color
    textColor: "#333",
    width: "310px",
  },
  spotlight: {
    borderRadius: 20,
  },
  tooltip: {
    borderRadius: 20,
    fontSize: "14px",
    padding: "16px",
  },
  tooltipContainer: {
    textAlign: "left",
  },
  tooltipContent: {
    padding:'6',
    textAlign: "left",
    fontSize: "14px",
    color:'#333',
    fontFamily:"graphikregular"
  },

  tooltipTitle: {
    textAlign: "left",
    marginBottom: "2px",
    fontSize: "18px",
    fontWeight: "bold",
    color:'black',    
    fontFamily: "graphikmedium"

  },
  buttonContainer: {
    textAlign: "left",
    marginTop: "15px",
    display: "flex",
    justifyContent: "flex-start",
  },
  tooltipFooter: {
    display: "block",
  },

  buttonNext: {
    backgroundColor: "#fff",
    borderRadius: "4px",
    color: "#118BF4",
    padding: "8px 16px",
    border: "2px solid #118BF4",
    borderRadius: "33px",
    width: "100px",
    boxShadow: "0px 3px 10px #b3b2af",
    padding: "10px",
    fontFamily:"graphikregular"
  }
};
